/**
 * Predefined tags for code generation
 * These tags can be used to categorize generated SILAE codes
 */
export const PREDEFINED_TAGS = [
  // Categories
  "Paie",
  "Prime",
  "Absence",
  "Congé",
  "Cotisation",
  "Heures supplémentaires",

  // Time periods
  "Mensuel",
  "Annuel",
  "Trimestriel",

  // Types
  "Obligatoire",
  "Optionnel",
  "Temporaire",

  // Status
  "Production",
  "Test",
  "Archive",

  // Common use cases
  "13ème mois",
  "Variable",
  "Cadre",
  "Non-cadre",
] as const;

export type PredefinedTag = (typeof PREDEFINED_TAGS)[number];
